(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ornament-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ornament-builder')) {
    customElements.define('ornament-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const rail = this.querySelector('[data-designs-rail]');
        const previous = this.querySelector('[data-scroll-prev]');
        const next = this.querySelector('[data-scroll-next]');
        const scrollRail = direction => {
          if (!rail) return;
          const amount = Math.max(rail.clientWidth * 0.85, 190);
          rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
        };
        previous?.addEventListener('click', () => scrollRail(-1));
        next?.addEventListener('click', () => scrollRail(1));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ornament-uploads"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ornament-uploads')) {
    customElements.define('ornament-uploads', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.urls = new Map();
        this.querySelectorAll('[data-upload-form]').forEach(form => {
          const input = form.querySelector('[data-file]');
          const error = form.querySelector('[data-error]');
          const preview = form.querySelector('[data-preview]');
          const img = form.querySelector('[data-preview-image]');
          const showError = message => { input.setCustomValidity(message); error.textContent = message; };
          input.addEventListener('change', () => {
            const previous = this.urls.get(input);
            if (previous) URL.revokeObjectURL(previous);
            this.urls.delete(input);
            preview.hidden = true;
            img.removeAttribute('src');
            showError('');
            const file = input.files[0];
            if (!file) return;
            if (!['image/jpeg','image/png'].includes(file.type)) { showError(input.dataset.typeError); return; }
            if (file.size > 10 * 1024 * 1024 || !file.size) { showError(input.dataset.sizeError); return; }
            const url = URL.createObjectURL(file);
            this.urls.set(input,url);
            img.onload = () => { if (this.urls.get(input) === url) preview.hidden = false; };
            img.onerror = () => { if (this.urls.get(input) === url) showError(input.dataset.readError); };
            img.src = url;
          });
          form.addEventListener('submit', event => {
            if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
            const button = form.querySelector('[data-submit]');
            button.disabled = true;
            button.textContent = button.dataset.loading;
          });
        });
      }
      disconnectedCallback() {
        this.urls?.forEach(url => URL.revokeObjectURL(url));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
